module.exports = __webpack_public_path__ + "media/features/use-cases/images/image_en-867f95c106e126d46151377bb27d4049.png";